<!-- 审核 -->
<template>
  <div class="diseaseList">
    <!-- 封装selectForm筛选 multiple collapse-tags-->
    <el-form :inline="true">
      <el-button type="primary" size="small" v-waves @click="handleAdd" v-if="userInfo.id == 1">新增</el-button>
      <!-- <el-form-item label="所属企业登录账号:" style="margin:0 20px" size="small">
        <el-select v-model="listQuery.admin_id" placeholder="请选择" clearable>
          <div v-for="(item, index) in accountList" :key="index">
            <el-option :label="item.alias_name" :value="item.id + ''"></el-option>
          </div>
        </el-select>
      </el-form-item>-->
      <el-form-item label="会员姓名: " style="margin:0 20px" size="small">
        <el-input v-model="listQuery.user_name" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="手机号: " style="margin-right:20px" size="small">
        <el-input v-model="listQuery.user_phone" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-button type="primary" @click="getListData" size="small" v-waves>搜索</el-button>
    </el-form>
    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="type" slot-scope="{ row }">
          {{
          arrayByIdToNameStr({
          ArrayData: vipCardList,
          ID: row.type,
          })
          }}
        </template>

        <template slot="money" slot-scope="{ row }">
          <el-tag type="success" effect="dark" size="mini">账户余额: {{row.money}}</el-tag>
        </template>

        <template slot="operation" slot-scope="{ row }">
          <div class="operation" v-if="userInfo.id == 1">
            <el-button size="mini" type="text" @click="handleEdit(row, 1)" primary>编辑</el-button>
            <el-button
              size="mini"
              type="text"
              @click="handleEdit(row, 2)"
              primary
            >充值</el-button>
            <el-button
              size="mini"
              type="text"
              @click="handleEdit(row, 3)"
              style="color: rgb(255, 0, 0);"
            >消费</el-button>
            <el-button
              size="mini"
              type="text"
              style="color: rgb(255, 0, 0);"
              @click="handleDelete(row)"
            >删除</el-button>
          </div>
        </template>
      </ElTable>

      <!-- 新增修改负责人表单 -->
      <el-dialog
        :title="dialogType == 0 ? '创建会员账户' : '编辑会员账户'"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form ref="form" :model="dialogForm" label-width="150px">
          <el-form-item label="会员等级: " required>
            <el-select
              v-model="dialogForm.type"
              placeholder="请选择"
              style="width: 100%;"
              clearable
            >
              <el-option
                v-for="item in vipCardList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="会员姓名" required>
            <el-input v-model="dialogForm.user_name" clearable></el-input>
          </el-form-item>

          <el-form-item label="手机号" required>
            <el-input v-model="dialogForm.user_phone" clearable :disabled="dialogType == 1"></el-input>
          </el-form-item>

          <el-form-item label="性别: ">
            <el-select v-model="dialogForm.sex" placeholder="请选择" style="width: 100%;" clearable>
              <el-option
                v-for="item in sexList"
                :label="item.name"
                :value="item.name"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="生日">
            <el-input v-model="dialogForm.birthday" clearable></el-input>
          </el-form-item>-->

          <!-- <el-form-item label="负责人卡有效期">
            <el-input v-model="dialogForm.categoryName" clearable></el-input>
          </el-form-item>-->

          <el-form-item label="备注">
            <el-input type="textarea" clearable v-model="dialogForm.msg"></el-input>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="save">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 充值消费负责人表单 -->
      <el-dialog
        :title="moneyInfo.type === 0 ? '账户充值' : '账户消费'"
        :visible.sync="dialogMoneyVisible"
        :close-on-click-modal="false"
      >
        <el-form ref="form" :model="moneyInfo" label-width="120px">
          <el-form-item label="卡号">
            <el-input :value="dialogForm.vip_number" disabled></el-input>
          </el-form-item>
          <el-form-item label="会员姓名">
            <el-input :value="dialogForm.user_name" disabled></el-input>
          </el-form-item>
          <el-form-item required :label="moneyInfo.type === 0?'充值金额' : '消费金额'">
            <el-input v-model="moneyInfo.money" clearable type="number"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" clearable v-model="moneyInfo.message"></el-input>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogMoneyVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveUpdateMoney">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import filterQueryFormItems from "./filterQueryFormItems";
import Percentage from "@/components/filters/Percentage.vue";
import FillingStatus from "@/components/filters/FillingStatus.vue";
import KindTab from "@/components/tab/kindTab/index.vue";
import StoreToString from "@/components/filters/storeToString.vue";
import {
  selectVipCard,
  addVipCard,
  updateVipCard,
  deleteVipCard,
  updateMoney,
  updateMaxLimit
} from "@/services/mall/vipCard";
// import { addVipcardRecoder } from "@/services/mall/vipcardRecode";
import { mapState } from "vuex";
import { selectAdmin } from "@/services/system/user.js";
import { arrayByIdToNameStr } from "@/utils/arrayByIdToNameStr";
export default {
  components: {
    ElTable,
    Percentage,
    FillingStatus,
    KindTab,
    StoreToString
  },
  async created() {
    this.getListData();
    this.selectAccountList();
  },
  data() {
    return {
      arrayByIdToNameStr,
      sexList: [{ name: "男" }, { name: "女" }],
      vipCardList: [
        { id: 0, name: "普通会员" },
        { id: 1, name: "白银会员" },
        { id: 2, name: "黄金会员" },
        { id: 3, name: "钻石会员" }
      ],
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      /* 表格数据 */
      tableData: [],
      /* 弹窗 */
      dialogName: "",
      dialogType: "",
      dialogForm: {},
      dialogFormVisible: false,
      dialogMoneyVisible: false,

      moneyInfo: {
        // type: "", //0充值 1消费
        // money: "",
        // message: "",
      },

      accountList: [],
      dialogMaxLimitVisible: false
    };
  },
  computed: {
    filterQueryFormItems,
    listHeader,
    ...mapState(["userInfo", "filterStoreList"])
  },
  watch: {},
  methods: {
    async selectAccountList() {
      const { data, code, count } = await selectAdmin({
        pageNumber: 1,
        pageSize: 1000,
        grade: 2
      });
      if (code === 200) {
        this.accountList = data.map(item => {
          return {
            ...item,
            name: item.alias_name,
            id: item.id
          };
        });
      }
    },

    async getListData() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      this.loading = true;
      const { data, code, count } = await selectVipCard({
        ...listQuery,
        admin_id: this.userInfo.id
      });
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },

    /* 搜索按钮 */
    async search(listQuery) {
      this.listQuery = listQuery;
      this.getListData();
    },

    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },

    /* 创建会员账户弹窗 */
    handleAdd(type) {
      this.dialogFormVisible = true;
      this.dialogType = 0;
      this.dialogForm = {};
    },

    /* 保存 */
    save() {
      if (!this.dialogForm.type && this.dialogForm.type !== 0) {
        this.$message.error("请选择会员类型");
        return;
      }
      if (!this.dialogForm.user_phone || !this.dialogForm.user_name) {
        this.$message.error("请填写必填字段");
        return;
      }
      /* 账号格式校验 */
      let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!reg_tel.test(this.dialogForm.user_phone)) {
        this.$message.error("手机号格式错误");
        return;
      }
      if (this.dialogType == 0) {
        addVipCard({
          ...this.dialogForm,
          create_user: `后台账号${this.userInfo.username}(ID:${this.userInfo.id})创建`
        }).then(res => {
          if (res.code === 200) {
            this.listQuery.pageNumber = 1;
            this.getListData();
            this.$message({
              type: "success",
              message: "创建成功!"
            });
            this.dialogFormVisible = false;
          }
        });
      }
      if (this.dialogType == 1) {
        updateVipCard(this.dialogForm).then(res => {
          if (res.code === 200) {
            this.getListData();
            this.$message({
              type: "success",
              message: "编辑成功!"
            });
            this.dialogFormVisible = false;
          }
        });
      }
    },

    /* 1修改，2充值，3消费 */
    handleEdit(row, index) {
      if (index === 1) {
        this.dialogFormVisible = true;
        this.dialogType = 1; //编辑会员账户
      }
      this.moneyInfo = {};
      if (index === 2) {
        if (
          (row.type === "惠信宝" && row.max_limit == 0) ||
          (row.type === "惠信宝" && row.money >= row.max_limit)
        ) {
          this.$message.error("惠信宝未使用额度不需要还款");
          return;
        }
        this.dialogMoneyVisible = true;
        this.moneyInfo.type = 0;
      }
      if (index === 3) {
        this.dialogMoneyVisible = true;
        this.moneyInfo.type = 1;
      }
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },
    /* 充值与消费 */
    saveUpdateMoney() {
      if (!this.moneyInfo.money || this.moneyInfo.money == 0) {
        this.$message.error("请填写正确的金额");
        return;
      }
      updateMoney({
        ...this.dialogForm,
        money: this.moneyInfo.money,
        type: this.moneyInfo.type,
        // user_phone,
        //        vip_number,
        // admin_id
        cancel_id: `${this.userInfo.username}(后台账号ID:${this.userInfo.id})`,
        amount:
          this.moneyInfo.type == 1
            ? -this.moneyInfo.money
            : this.moneyInfo.money,
        message: this.moneyInfo.message
      }).then(res => {
        if (res.code === 200) {
          this.listQuery.pageNumber = 1;
          this.getListData();
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.dialogMoneyVisible = false;
        }
      });
    },

    handleMaxLimit(row) {
      this.dialogForm = JSON.parse(JSON.stringify(row));
      this.dialogMaxLimitVisible = true;
    },
    /* 调整总额度 */
    saveMaxLimit() {
      if (!this.moneyInfo.max_limit && this.moneyInfo.max_limit !== 0) {
        this.$message.error("请填写正确的金额");
        return;
      }
      updateMaxLimit({
        ...this.dialogForm,
        max_limit: this.moneyInfo.max_limit,
        type: this.moneyInfo.type,
        cancel_id: `${this.userInfo.username}(后台账号ID:${this.userInfo.id})`
      }).then(res => {
        if (res.code === 200) {
          this.listQuery.pageNumber = 1;
          this.getListData();
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.dialogMaxLimitVisible = false;
        }
      });
    },

    /* 删除 */
    handleDelete(row) {
      this.$confirm(`确定删除手机号为"${row.user_phone}"的账户吗?`, "禁用", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(res => {
        deleteVipCard({ id: row.id, vip_number: row.vip_number }).then(res => {
          if (res.code === 200) {
            this.getListData();
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          }
        });
      });
    }
  }
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}
.selectForm {
  background: #fff;
  // max-width: 1405px;
  padding: 10px 0;
  margin: 10px auto;
}
.tableList {
  border-radius: 6px;
  background: #fff;
  // max-width: 1405px;
  margin: 10px auto;
}

.operation {
  a {
    margin-right: 10px;
  }
}
.tip {
  color: rgb(255, 106, 0);
}
</style>
